import { ClientWebEmbeddingMessage } from '@cp/common/clientWebEmbedding';
import React from 'react';

export * from './store';

export interface IEmbeddingContext {
  postMessage: (message: ClientWebEmbeddingMessage) => void;
}

export const EmbeddingContext = React.createContext<IEmbeddingContext>({
  postMessage() {
    throw new Error('EmbeddingContext is not set');
  },
});

export const useEmbedding = () => React.useContext(EmbeddingContext);
